import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AsociaAdmin.css";
import PedidosPendientes from "../components/AsociaComponents/PedidosPendientes";
import PedidosEntregar from "../components/AsociaComponents/PedidosEntregar";
import RealizarVenta from "../components/AsociaComponents/RealizarVenta";
import CartTable from "../components/AsociaComponents/carritoTemp";
import {
  getProcessingOrders,
  getValidatedAndProcessingOrders,
    getValidatedAndProcessingDocuments,
} from "../services/Carrito/getOrders&Invoices";

export const AsociaAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { nombre, id } = location.state || {};
  const [activePage, setActivePage] = useState("panel-general");
  const [pendientesCount, setPendientesCount] = useState(null);
  const [loadingPendientes, setLoadingPendientes] = useState(true);
  const [loadingEntregar, setLoadingEntregar] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const [pedidosCount, setPedidosCount] = useState(null);

  const usuarioActual = localStorage.getItem("asociaName");

  const usuariosPermitidos = [
    "AEMTEC",
    "ADESC",
    "AESETEC",
    "ASEIC",
    "Andres",
    "Pablo",
  ];

  const handleLogout = () => {
    localStorage.removeItem("asociaName");
    localStorage.removeItem("asociaId");
    localStorage.removeItem("carritoActual");
    navigate("/asocias");
  };

  let userValue;
  switch (usuarioActual) {
    case "ASEIC":
      userValue = 1;
      break;
    case "AEMTEC":
      userValue = 2;
      break;
    case "PABLO":
      userValue = 3;
      break;
    case "ANDRÉS":
      userValue = 5;
      break;
    case "AESETEC":
      userValue = 4;
      break;
    case "ADESC":
      userValue = 6;
      break;
    default:
      userValue = null;
  }

  useEffect(() => {
    const verificarUsuario = () => {
      const usuarioActual = localStorage.getItem("asociaName");
      if (!usuariosPermitidos.includes(usuarioActual)) {
        navigate("/");
      }
    };
    verificarUsuario();
  }, [navigate]);

  const fetchCounts = async () => {
    try {
      // Pedidos por alistar
      const allPorAlistar = await getProcessingOrders(userValue.toString());
      // Filter orders based on warehouse_id
      const filteredPorAlistar = allPorAlistar.filter(order => {
        if (order.warehouse_id === null) {
          // Si warehouse_id es null, solo mostrar a Pablo (3) o Andrés (5)
          return userValue === 3 || userValue === 5;
        }
        // Si no es null, mostrar solo los que coincidan con userValue
        return order.warehouse_id === userValue.toString();
      });
      setPendientesCount(filteredPorAlistar.length);
    } catch (error) {
      console.error("Error al obtener pedidos pendientes (por alistar):", error);
    } finally {
      setLoadingPendientes(false);
    }

    try {
      // Pedidos por entregar (orders + invoices)
      const [ordersPorEntregar, invoicesPorEntregar] = await Promise.all([
        getValidatedAndProcessingDocuments("orders", userValue.toString()),
        getValidatedAndProcessingDocuments("invoices", userValue.toString())
      ]);

      const allPorEntregar = [
        ...ordersPorEntregar,
        ...invoicesPorEntregar
      ];

      const filteredPorEntregar = allPorEntregar.filter(order => {
        // Usuarios con acceso total
        if ([3, 4, 5].includes(Number(userValue))) {
          return true;
        }

        // Resto de usuarios: solo su bodega
        return order.warehouse_id === userValue.toString();
      });

      setPedidos(filteredPorEntregar);
      setPedidosCount(filteredPorEntregar.length);

    } catch (error) {
      console.error("Error al obtener pedidos por entregar:", error);
    } finally {
      setLoadingEntregar(false);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  useEffect(() => {
    if (activePage === "panel-general") {
      fetchCounts();
    }
  }, [activePage]);

  const navigationTabs = [
    {
      id: "panel-general",
      label: "Panel General",
      icon: "🏠 ",
    },
    {
      id: "pedidos-pendientes",
      label: "Por Alistar",
      icon: "📦 ",
      badge: pendientesCount,
      loading: loadingPendientes,
    },
    {
      id: "pedidos-por-entregar",
      label: "Por Entregar",
      icon: "🚚 ",
      badge: pedidosCount,
      loading: loadingEntregar,
    },
    {
      id: "realizar-venta",
      label: "Realizar Venta",
      icon: "➕ ",
    },
    {
      id: "venta",
      label: "Carrito",
      icon: "🛒 ",
    },
  ];

  return (
    <div className="new-admin-container">
      {/* Header */}
      <header className="admin-header">
        <div className="header-content">
          <div className="header-left"> 
            <h1 className="admin-title">Volteon Electronics</h1>
            <span className="welcome-text">Bienvenido, {nombre}</span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            Cerrar Sesión
          </button>
        </div>
      </header>

      {/* Navigation Tabs */}
      <nav className="admin-nav">
        <div className="nav-content">
          <div className="nav-tabs">
            {navigationTabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActivePage(tab.id)}
                className={`nav-tab ${activePage === tab.id ? "active" : ""}`}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
                {tab.badge !== null && tab.badge !== undefined && (
                  <span className="tab-badge">
                    {tab.loading ? "..." : tab.badge}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="admin-main">
        {activePage === "panel-general" && (
          <div className="panel-general-new">
            <div className="panel-header">
              <h2 className="panel-title">Panel General</h2>
              <p className="panel-subtitle">
                Resumen de actividades y acciones rápidas
              </p>
            </div>

            {/* Stats Grid */}
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-content">
                  <div className="stat-icon">📦</div>
                  <div className="stat-info">
                    <h3 className="stat-label">Pedidos por Alistar</h3>
                    <p className="stat-value">
                      {loadingPendientes ? "Cargando..." : pendientesCount || 0}
                    </p>
                  </div>
                </div>
                <div className="stat-action">
                  <button
                    onClick={() => setActivePage("pedidos-pendientes")}
                    className="stat-btn"
                  >
                    Ver todos
                  </button>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-content">
                  <div className="stat-icon">🚚</div>
                  <div className="stat-info">
                    <h3 className="stat-label">Pedidos por Entregar</h3>
                    <p className="stat-value">
                      {loadingEntregar ? "Cargando..." : pedidosCount || 0}
                    </p>
                  </div>
                </div>
                <div className="stat-action">
                  <button
                    onClick={() => setActivePage("pedidos-por-entregar")}
                    className="stat-btn"
                  >
                    Ver todos
                  </button>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="quick-actions">
              <h3 className="quick-actions-title">Acciones Rápidas</h3>
              <div className="quick-actions-buttons">
                <button
                  onClick={() => setActivePage("realizar-venta")}
                  className="quick-btn primary"
                >
                  <span> ➕ </span>
                  Nueva Venta
                </button>
                <button
                  onClick={() => setActivePage("venta")}
                  className="quick-btn secondary"
                >
                  <span>🛒</span>
                  Ver Carrito
                </button>
              </div>
            </div>
          </div>
        )}

        {activePage === "pedidos-pendientes" && (
          <div className="page-content">
            <div className="page-nav">
              <button
                onClick={() => setActivePage("panel-general")}
                className="back-btn"
              >
                ← Volver al Panel General
              </button>
            </div>
            <PedidosPendientes setPendientesCount={setPendientesCount} />
          </div>
        )}

        {activePage === "pedidos-por-entregar" && (
          <div className="page-content">
            <div className="page-nav">
              <button
                onClick={() => setActivePage("panel-general")}
                className="back-btn"
              >
                ← Volver al Panel General
              </button>
            </div>
            <PedidosEntregar
                setPedidosCount={setPedidosCount}
                pedidos={pedidos}
                refreshOrders={fetchCounts}
                isLoading={loadingEntregar}  // ← pass this
            />
          </div>
        )}

        {activePage === "realizar-venta" && (
          <div className="page-content">
            <div className="page-nav">
              <button
                onClick={() => setActivePage("panel-general")}
                className="back-btn"
              >
                ← Volver al Panel General
              </button>
              <button
                onClick={() => setActivePage("venta")}
                className="nav-action-btn"
              >
                🛒 Ver Carrito
              </button>
            </div>
            <RealizarVenta />
          </div>
        )}

        {activePage === "venta" && (
          <div className="page-content">
            <div className="page-nav">
              <button
                onClick={() => setActivePage("panel-general")}
                className="back-btn"
              >
                ← Volver al Panel General
              </button>
              <button
                onClick={() => setActivePage("realizar-venta")}
                className="nav-action-btn"
              >
                ➕ Agregar Productos
              </button>

            </div>
            <CartTable />
          </div>
        )}
      </main>
    </div>
  );
};
